import { ThemeProvider as MUIThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import { Helmet } from 'react-helmet'
import { baseMUITheme } from './themeBase'

export const CHTCtheme = ({ children }) => {
  // const { mode } = useTheme()

  // Update the theme only if the mode changes
  const theme = baseMUITheme()

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <Helmet>
          <style>
            {`
                :root {
                  --primary: ${theme.palette.primary.main};
                  --secondary: ${theme.palette.secondary.main};
                  --error: ${theme.palette.error.main};
                  --bg-default: ${theme.palette.background.default}; 
                  --bg-paper: ${theme.palette.background.paper}; 
                  --text-body: ${theme.palette.text.primary}; 
                  --text-muted: ${theme.palette.text.secondary}; 
                  --text-hint: ${theme.palette.text.hint}; 
                  ${theme.shadows
                .map((shadow, i) => {
                  return `--elevation-z${i}: ${shadow};`
                })
                .join(' ')} 

                }
              `}
          </style>
          <script
            async
            src={`https://www.googletagmanager.com/gtag/js?id=${sfOauthConfig.config.gaConfig}`}
          />
          <script>{`
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', '${sfOauthConfig.config.gaConfig}');
              `}
          </script>
        </Helmet>
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  )
}
